export default "__VITE_ASSET__1uqBJVlu__"